import { render } from "./InfoMeta.vue?vue&type=template&id=4537b566&scoped=true"
import script from "./InfoMeta.vue?vue&type=script&lang=js"
export * from "./InfoMeta.vue?vue&type=script&lang=js"

import "./InfoMeta.vue?vue&type=style&index=0&id=4537b566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4537b566"]])

export default __exports__